import { isNode } from '../helpers';

export function removeFlyntCommentsVisitor(node) {
  if (isNode(node)) {
    if (node.data?.docs?.summary) {
      node.data.docs.summary = removeFlyntComment(node.data.docs.summary);
    }

    if (node.data?.docs?.description) {
      node.data.docs.description = removeFlyntComment(
        node.data.docs.description,
      );
    }

    removeFlyntCommentsFromMembers(node.data);
  }
}

function removeFlyntCommentsFromMembers(nodeData) {
  const removeFrom = [
    'operations',
    'clientEvents',
    'messages',
    'callbacks',
    'properties',
    'relatedGuides',
    'events',
  ];

  removeFrom.forEach((key) => {
    if (nodeData[key]) {
      nodeData[key] = nodeData[key].map((prop) => {
        return prop?.docs?.summary
          ? {
              ...prop,
              docs: {
                ...prop.docs,
                summary: removeFlyntComment(prop.docs?.summary),
                description: removeFlyntComment(prop.docs?.description),
              },
            }
          : prop;
      });
    }
  });
}

function removeFlyntComment(docsString: string | string[] = '') {
  if (Array.isArray(docsString)) {
    return docsString.map(removeFlyntComment);
  } else {
    return docsString.replace(/(\n|\s)?flynt-disable [^\s]+ ?(\n)?/gim, ''); // https://regex101.com/r/18aCj9/1
  }
}
